import React from "react";
import { BecomeAListenerBanner } from "./BecomeAListenerBanner";
import { WhyThisMatters } from "./WhyThisMatters";
import { WhoCanTakeThisCourse } from "./WhoCanTakeThisCourse";
import { FrequentlyAskQuestions } from "./FrequentlyAskQuestions";

import "./index.css";

export const BecomeAListener = () => {
  return (
    <div className="BecomeAListenerhomeContainer">
      <BecomeAListenerBanner />
      <WhyThisMatters />
      <WhoCanTakeThisCourse />
      <FrequentlyAskQuestions />
    </div>
  );
};
